export default __webpack_public_path__ + "static/media/OEKO TEX Certificate.21bfd894.png";